import React from 'react';
import { useParams } from 'react-router-dom';
import { LPLink, LPText } from '../../styles';
import { ContentWrapper } from '../styles';
import BookingNav from './BookingNav';
import BookingFooter from './BookingFooter';

const BookingSuccess = () => {
  const { virtualPhoneNumber } = useParams();

  return (
    <>
      <ContentWrapper>
        <LPText padded w800>
          All set 🙌 - Check your inbox, just sent you a confirmation TEXT 💯. See you soon 🙏!
        </LPText>
        <BookingNav isExpanded isFinal />
      </ContentWrapper>

      <LPLink to={`/s/${virtualPhoneNumber}`}>
        <BookingFooter footerHeading="Done" footerParagraph="Tab here to view my links." />
      </LPLink>
    </>
  );
};

BookingSuccess.propTypes = {};

export default BookingSuccess;
